// Core features needed in all subsites
import './modules/core';

/* ========================================================================
 * Palmia specific scripts (legacy stuff, just modularized a bit)
 * MAKE MODULES IF YOU DO ANYTHING NEW
 * ======================================================================== */

import $ from 'jquery';

import naviPopupNotice from './modules/navi-popup-notice';
import serviceList from './modules/service-list';
import serviceSearch from './modules/service-search';
import jobSearch from './modules/job-search';

serviceList.init();
serviceSearch.init();
jobSearch.init();
naviPopupNotice.init();

// Desktop header form
$('.js-form-wrapper').show();
$('.js-icon-magnify').on('click', function() {
  // animate form down
  // animate input width
  $('.js-form-wrapper').toggleClass('expand').find('input').trigger('focus');
});
